export default __webpack_public_path__ + "static/media/santa_rosa.ae2cae03.jpeg";